module.exports = __webpack_public_path__ + "static/media/northville-hills-rules-regs.81cf55ee.pdf";